import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-paperless-promo-modal',
  imports: [BaseModalComponent, MatIconModule, MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './paperless-promo-modal.component.html',
  styleUrl: './paperless-promo-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaperlessPromoModalComponent {
  isOpen = input<boolean>(false);

  userEmail = input<string>('');

  isLoading = input<boolean>(false);

  accept = output<void>();

  decline = output<void>();

  protected onAccept(): void {
    if (!this.isLoading()) {
      this.accept.emit();
    }
  }

  protected onDecline(): void {
    if (!this.isLoading()) {
      this.decline.emit();
    }
  }
}
